export function calculateTimeSinceUpdate(updated_time, fallback) {
  if (!updated_time && fallback !== undefined) {
    console.warn("updated_time is undefined or null, using fallback value.");
    return fallback;
  }

  const tripUpdateTime = updated_time ? new Date(updated_time).getTime() : Date.now();

  // Calculate the difference in seconds
  const secondsSinceLastUpdate = Math.floor((Date.now() - tripUpdateTime) / 1000);
  return secondsSinceLastUpdate;
}

// ETA session storage functions
const ETA_STORAGE_PREFIX = 'eta_';

export function storeETA(tripId, eta, driverOffset = null) {
  if (!tripId) return;
  if (driverOffset === null) {
    const saved = getStoredETA(tripId);
    driverOffset = saved?.driverOffset ?? 0;
  }
  sessionStorage.setItem(`${ETA_STORAGE_PREFIX}${tripId}`, JSON.stringify({ eta, driverOffset }));
}

export function getStoredETA(tripId) {
  if (!tripId) return null;
  const data = sessionStorage.getItem(`${ETA_STORAGE_PREFIX}${tripId}`);
  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch (e) {
    console.error('Failed to parse stored ETA:', e);
    return null;
  }
}

export function clearStoredETA(tripId) {
  if (!tripId) return;
  sessionStorage.removeItem(`${ETA_STORAGE_PREFIX}${tripId}`);
}

/**
 * Constructs the full URL for an image, handling both external URLs and local media files.
 * @param {string} image - The image path or URL. Can be a full URL (starting with http:// or https://) or a relative path.
 * @param {string} apiUrl - The base API URL to use for constructing local media URLs.
 * @returns {string} The full image URL. Returns empty string if image is not provided.
 */
export function getImageUrl(image, apiUrl) {
  if (!image) return '';
  if (!apiUrl) {
    console.warn('getImageUrl: apiUrl is not provided, returning image as-is');
    return image;
  }
  return image.startsWith('http://') || image.startsWith('https://') ? image : `${apiUrl}/media/${image}`;
}

// helper to get the current pathname relative to the app basename
export const getRelativePath = () => {
  const envBase = (
    process.env.REACT_APP_BASE_PATH ||
    process.env.PUBLIC_URL ||
    ""
  ).replace(/\/$/, "");
  if (typeof window === "undefined") return "/";
  const raw = window.location.pathname || "/";
  if (!envBase) return raw;
  if (raw === envBase) return "/";
  return raw.startsWith(envBase) ? raw.slice(envBase.length) || "/" : raw;
};

